<template>
  <section class="sections-achievements">
    <div class="sections-achievements__container container">
      <div class="sections-achievements__body">
        <CSpriteIcon
          v-for="item in 8"
          :key="item"
          class="sections-achievements__icon sections-achievements__icon--plus"
          :class="`sections-achievements__icon--plus--${item}`"
          name="plus"
        />

        <div class="sections-achievements__part">
          <div class="sections-achievements__item">
            <CSpriteIcon
              name="icon_countries"
              class="sections-achievements__icon sections-achievements__icon--achievement"
            />

            <div class="sections-achievements__text">
              <div class="sections-achievements__value">
                <span
                  class="sections-achievements__font sections-achievements__font--value"
                >
                  22
                </span>
              </div>

              <div class="sections-achievements__label">
                <span
                  class="sections-achievements__font sections-achievements__font--label"
                >
                  Countries
                </span>
              </div>
            </div>
          </div>

          <div class="sections-achievements__item">
            <CSpriteIcon
              name="icon_carriers"
              class="sections-achievements__icon sections-achievements__icon--achievement"
            />

            <div class="sections-achievements__text">
              <div class="sections-achievements__value">
                <span
                  class="sections-achievements__font sections-achievements__font--value"
                >
                  36
                </span>
              </div>

              <div class="sections-achievements__label">
                <span
                  class="sections-achievements__font sections-achievements__font--label"
                >
                  Carriers
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="sections-achievements__part">
          <div class="sections-achievements__item">
            <CSpriteIcon
              name="icon_directions"
              class="sections-achievements__icon sections-achievements__icon--achievement"
            />

            <div class="sections-achievements__text">
              <div class="sections-achievements__value">
                <span
                  class="sections-achievements__font sections-achievements__font--value"
                >
                  275K
                </span>
              </div>

              <div class="sections-achievements__label">
                <span
                  class="sections-achievements__font sections-achievements__font--label"
                >
                  Directions
                </span>
              </div>
            </div>
          </div>

          <div class="sections-achievements__item">
            <CSpriteIcon
              name="icon_travelers"
              class="sections-achievements__icon sections-achievements__icon--achievement"
            />

            <div class="sections-achievements__text">
              <div class="sections-achievements__value">
                <span
                  class="sections-achievements__font sections-achievements__font--value"
                >
                  125K
                </span>
              </div>

              <div class="sections-achievements__label">
                <span
                  class="sections-achievements__font sections-achievements__font--label"
                >
                  Happy Travelers
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.sections-achievements {
  overflow: hidden;
  background: url('#{$images-path}/red_map_background.webp') center / cover
    no-repeat;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  &__font {
    display: block;

    &--value {
      font-size: em(36);
      font-weight: 800;
      line-height: 100%;

      @include media-breakpoint-down(md) {
        font-size: em(29);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(23);
      }
    }

    &--label {
      font-family: $font-family-second;
      font-size: em(18);
      font-weight: 500;
      line-height: 100%;

      @include media-breakpoint-down(md) {
        font-size: em(14);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(11);
      }
    }
  }

  &__icon {
    &--achievement {
      width: em(50);
      height: em(50);

      @include media-breakpoint-down(md) {
        width: em(40);
        height: em(40);
      }

      @include media-breakpoint-down(sm) {
        width: em(32);
        height: em(32);
      }
    }

    &--plus {
      position: absolute;
      width: em(40);
      height: em(40);
      pointer-events: none;
      opacity: 0.5;

      &--1 {
        top: 0;
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(-4);
          left: em(-19);
        }

        @include media-breakpoint-down(sm) {
          top: em(-7);
          left: em(-20);
        }
      }

      &--2 {
        top: em(120);
        left: 0;

        @include media-breakpoint-down(md) {
          top: em(91);
          left: em(-19);
        }

        @include media-breakpoint-down(sm) {
          top: em(69);
          left: em(-20);
        }
      }

      &--3 {
        top: 0;
        left: em(520);

        @include media-breakpoint-down(md) {
          top: em(-4);
          right: em(-19);
          left: unset;
        }

        @include media-breakpoint-down(sm) {
          top: em(-6);
          right: em(-21);
        }
      }

      &--4 {
        top: em(120);
        left: em(520);

        @include media-breakpoint-down(md) {
          top: em(91);
          right: em(-19);
          left: unset;
        }

        @include media-breakpoint-down(sm) {
          top: em(69);
          right: em(-21);
        }
      }

      &--5 {
        top: 0;
        left: em(560);

        @include media-breakpoint-down(md) {
          top: em(122);
          left: em(-19);
        }

        @include media-breakpoint-down(sm) {
          top: em(95);
          left: em(-20);
        }
      }

      &--6 {
        top: em(120);
        left: em(560);

        @include media-breakpoint-down(md) {
          top: em(218);
          left: em(-19);
        }

        @include media-breakpoint-down(sm) {
          top: em(170);
          left: em(-20);
        }
      }

      &--7 {
        top: 0;
        left: em(1080);

        @include media-breakpoint-down(md) {
          top: em(122);
          right: em(-19);
          left: unset;
        }

        @include media-breakpoint-down(sm) {
          top: em(95);
          right: em(-20);
        }
      }

      &--8 {
        top: em(120);
        left: em(1080);

        @include media-breakpoint-down(md) {
          top: em(218);
          right: em(-19);
          left: unset;
        }

        @include media-breakpoint-down(sm) {
          top: em(170);
          right: em(-20);
        }
      }
    }
  }

  &__container {
    @include media-breakpoint-down(md) {
      max-width: em(704);
    }
  }

  &__body {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: em(40);

    @include media-breakpoint-down(md) {
      flex-direction: column;
      padding: em(30) em(15);
    }

    @include media-breakpoint-down(sm) {
      flex-direction: column;
      padding: em(28) em(15);
    }
  }

  &__part {
    display: flex;
    justify-content: space-between;
    width: em(480);
    padding: em(13) em(20);
    background-color: rgba($color-white, 0.05);
    backdrop-filter: blur(5px);
    border-radius: em(16);

    &:not(:last-child) {
      @include media-breakpoint-down(md) {
        margin-bottom: em(60);
      }

      @include media-breakpoint-down(sm) {
        margin-bottom: em(55);
      }
    }

    @include media-breakpoint-down(md) {
      width: 100%;
      padding: em(12) em(16);
    }

    @include media-breakpoint-down(sm) {
      padding: em(6) em(12);
      border-radius: em(10);
    }
  }

  &__item {
    display: flex;
    align-items: center;

    @include media-breakpoint-down(md) {
      width: 50%;
    }
  }

  &__text {
    margin-left: em(10);

    @include media-breakpoint-down(sm) {
      margin-left: em(6);
    }
  }

  &__value {
    color: $color-white;
    text-transform: uppercase;
  }

  &__label {
    color: $text-dark-on-red;
    text-transform: uppercase;
  }
}
</style>
